import {ajax, replacePath, checkResponseOKStatus} from "../../common/utils";
import {SET_POST_ACTION_KEY, SET_STORE_COMMENT, SET_UNAVAILABLE_ITEMS, SET_DROPDOWN_CLOSED} from "../actionTypes";
import {getOrderedItems, getOrderedItemsForSummary} from "../../common/basket";
import {replace} from "react-router-redux";
import {fetchingData, errorFetching} from '../common/fetchingActions';
import {getAuthorizedDotNetIFrameInfo, handlePaymentRedirect} from '../pay/paymentActions';
import {FetchingTypes, PaymentMethod} from "../../common/constants";
import {removePath} from "../../common/utils";
import {trackStoreCheckout} from "../../actions/common/gaActions";

export function submitOrder(memberKey, subscriptionKey, orderKey, items, activeOrder, canEditExistingOrder, hasPreapproval, storeComments, method, isChargeOnDelivery){
    return function (dispatch) {
        dispatch(trackStoreCheckout(hasPreapproval ? "Preapprove" : method));

        //Check if need first to create a token
        if (isChargeOnDelivery && !hasPreapproval && method === PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key) {
            //store the store comments for later order update
            dispatch(setStoreComment(storeComments));
            //Get the authorize.net ifarme to embed in the page
            dispatch(getAuthorizedDotNetIFrameInfo('STORE'));
        } else {
            //check if member already has existing order in that case we will call addToWeborder service instead of update service
            const itemsDivided = getOrderedItemsForSummary(items, activeOrder, canEditExistingOrder);
            const hasFixedItems = (itemsDivided.fixedItems && itemsDivided.fixedItems.length > 0) || (itemsDivided.creditFixedItems && itemsDivided.creditFixedItems.length > 0);
            if (hasFixedItems) {
                items = itemsDivided.editableItems || [];
                if (itemsDivided.creditEditableItems && itemsDivided.creditEditableItems.length > 0 ) {
                    items = items.concat(itemsDivided.creditEditableItems);
                }
            }
            //addToWebOrder
            dispatch(submit(memberKey, items, orderKey, storeComments, method, hasFixedItems, hasPreapproval, isChargeOnDelivery, subscriptionKey));
        }
    }
}

function submit(memberKey, items, orderKey, storeComments, method, hasFixedItems, hasPreapproval, isChargeOnDelivery, subscriptionKey) {
    return function (dispatch, getState) {
        const state = getState();
        let fetchUrl = hasFixedItems ? '/dispatcher/WebStoreService.addToWebOrder' : '/dispatcher/WebStoreService.updateOrder';
        //Remove uneeded data before sending to server
        let orderedItems = getOrderedItems(items, false).map(item => {
            item.description = undefined;
            item.imageUrl = undefined;
            item.producerTitle = undefined;
            item.link = undefined;
            item.producer = undefined;
            return item;
        });
        if(state.staticData.hasRecurringItems && (state.recurringOrder.items || []).length > 0) {
            const recurringOrder = state.recurringOrder;
            const recurringItems = recurringOrder.items || [];
            recurringItems.map(function (recurringItem) {
                let itemIndex = -1;
                (orderedItems||[]).find(function (item, index) {
                    if(item && item.key === recurringItem.key) {
                        itemIndex = index;
                    }
                });
                recurringItem.scheduleKey = recurringItem.schedule?recurringItem.schedule.key:undefined;
                if(itemIndex > -1) {
                    orderedItems[itemIndex].scheduleKey = recurringItem.scheduleKey;
                    orderedItems[itemIndex].isItemNotPartOfOrder = recurringItem.isItemNotPartOfOrder;
                    orderedItems[itemIndex].isRecurring = recurringItem.isRecurring;
                } else if(recurringItem.scheduleKey && recurringItem.quantity > 0 && state.summary.nextDeliveryDate){
                    recurringItem.isItemNotPartOfOrder = !recurringItem.schedule.dates.includes(state.summary.nextDeliveryDate);
                    delete recurringItem['schedule'];
                    orderedItems.push(recurringItem);
                }
            }.bind(orderedItems));

        }
        const coupon = (state.orderStatus || {}).coupon;
        const data = {
            farmKey: state.staticData.farmKey,
            memberKey: memberKey,
            orderKey: orderKey,
            paymentMethod: method ? method : "BALANCE",
            comments: storeComments,
            items: JSON.stringify(orderedItems),
            pickupSiteKey: state.summary.pickupSite.key
        };
        if ((coupon || {}).valid) {
            const enabledPaymentMethods = [PaymentMethod.PAYPAL_STANDARD, PaymentMethod.ELECTRONIC_CHECK, PaymentMethod.CHECK, PaymentMethod.AUTHORIZE_DOT_NET, PaymentMethod.EBT_ONLINE];
            const storePaymentMethods = state.staticData.storePaymentMethods;
            if((coupon || {}).existingCoupon) {
                const dontSendCoupon = enabledPaymentMethods.some(function (method) {
                    return storePaymentMethods.includes(method.key);
                });
                if(!dontSendCoupon) {
                    data.couponKey = coupon.key;
                    data.couponId = coupon.id;
                }
            } else {
                data.couponKey = coupon.key;
                data.couponId = coupon.id;
            }
        }
        //In case the farm has charge on delivery and the member doesn't have token already we need to call redirectToPayment
        // service which will call payPal API to get pre-approval key and save new postAction in the datastore that will be used
        // when we will receive paypal/ipn callback
        if (isChargeOnDelivery && !hasPreapproval && (method === PaymentMethod.PAYPAL_PREAPPROVE.key || method === PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key)) {
            fetchUrl = '/dispatcher/WebStoreService.redirectToPaymentDetails';
            data.mode = "STORE";
            data.subscriptionKey = subscriptionKey;
        }
        if(state.staticData.isMultipleActiveOrdersEnabled && state.summary.secondNextDeliveryDate !== undefined) {
            data.nextDeliveryDate = state.summary.nextDeliveryDate;
        }
        dispatch(fetchingData(FetchingTypes.SUBMIT));
        return ajax(fetchUrl, data)
            .then(json => {
                dispatch(handlePaymentRedirect(json, method, replace(replacePath('thankyou'))))
            })
            .catch(error => {
                dispatch(errorFetching(error));
            });
    }
}

export function checkAuthorizeDotNetTokenAndSubmitOrder(){
    return function(dispatch, getState) {
        const state = getState();
        const status = (state.orderStatus || {});
        const summary = state.summary || {};
        const memberKey = state.memberDetails.key;
        const subscriptionKey = summary.key;
        const orderKey = status.orderKey;
        const items = state.itemsList;
        const activeOrder = status.activeOrder;
        const canEditExistingOrder = summary.canEditExistingOrder;
        const storeComments = status.comments;

        const fetchUrl = '/dispatcher/WebStoreService.checkAuthorizeDotNetToken';
        let data = {
            farmKey: state.staticData.farmKey,
            memberKey: memberKey,
            subscription: subscriptionKey
        };
        if (state.checkout.postActionKey)
            data.postAction = state.checkout.postActionKey;
        dispatch(fetchingData(FetchingTypes.SUBMIT));
        return ajax(fetchUrl, data)
            .then(json => {
                checkResponseOKStatus(json);
                dispatch(submitOrder(memberKey, subscriptionKey, orderKey, items, activeOrder, canEditExistingOrder, true, storeComments, 'NONE', status.coupon));
            })
            .catch(error => {
                dispatch(replace(removePath('/payments')));
                dispatch(errorFetching(error));
            });
    }
}

export function updateACHPreapprovalAndSubmitOrder(echeckInfo){
    return function(dispatch, getState) {
        const state = getState();
        const status = (state.orderStatus || {});
        const summary = state.summary || {};
        const memberKey = state.memberDetails.key;
        const subscriptionKey = summary.subscriptionKey;
        const orderKey = status.orderKey;
        const items = state.itemsList;
        const activeOrder = status.activeOrder;
        const canEditExistingOrder = summary.canEditExistingOrder;
        const storeComments = status.comments;

        const fetchUrl = '/dispatcher/WebStoreService.updateACHPreapproval';
        dispatch(fetchingData(FetchingTypes.SUBMIT));
        return ajax(fetchUrl, echeckInfo)
            .then(json => {
                checkResponseOKStatus((json));
                dispatch(submitOrder(memberKey, subscriptionKey, orderKey, items, activeOrder, canEditExistingOrder, true, storeComments, 'NONE'));
            })
            .catch(error => {
                dispatch(errorFetching(error));
            });
    }
}

export function setPostActionKey(key) {
	return {
		type: SET_POST_ACTION_KEY,
		postActionKey: key
	}
}
function setStoreComment(comments){
    return {
        type: SET_STORE_COMMENT,
        comments
    }
}

export function setUnavailableItemsInOrder(items){
    return {
        type: SET_UNAVAILABLE_ITEMS,
        items: items
    }
}
export function dropDownClosed(isDropDownClosed) {
    return {
        type: SET_DROPDOWN_CLOSED,
        isDropDownClosed
    }
}


// WEBPACK FOOTER //
// ./src/actions/store/storeCheckoutActions.js